import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import CheckboxWithLabel from '../../kit/atoms/CheckboxWithLabel';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './AccordionItem.module.scss';
import Typography from '../../kit/atoms/Typography';
import Plus from '../../kit/icons/Plus';
import Minus from '../../kit/icons/Minus';

import { Facet, FacetData, FacetOptions } from '../../types';

export interface AccordionItemProps extends React.PropsWithChildren<any> {
    data: Facet;
    activeFilters?: FacetData[];
    onToggle?: Function;
    isItemActive?: (facetName: string, value: string) => boolean;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
    data,
    onToggle,
    activeFilters,
    isItemActive
}) => {
    const st: CssModuleType = currentCssModule;
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        const hasFacet = activeFilters?.some(
            (item) => item.facet_name === data.name
        );

        hasFacet && setOpen(true);
    }, []);

    return (
        <div className={clsx(st['accordion-item'], [isOpen && st.open])}>
            <div
                className={st['accordion-item__heading']}
                onClick={() => setOpen(!isOpen)}
            >
                <Typography variant='p'>
                    {data.display_name.startsWith('Price_')
                        ? 'Price'
                        : data.display_name}
                </Typography>
                {isOpen && <Minus />}
                {!isOpen && <Plus />}
            </div>
            <div className={st['accordion-item__body']}>
                {data?.options &&
                    data.options.map((item: FacetOptions, ind) => {
                        const itemValue = item.value.replace(/["\\]/g, '');

                        return (
                            <CheckboxWithLabel
                                item={item}
                                facetName={data.name}
                                onToggle={onToggle}
                                key={`${data.name}_${itemValue}`}
                                isChecked={isItemActive(data.name, itemValue)}
                            />
                        );
                    })}
            </div>
        </div>
    );
};

export default AccordionItem;
